export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request;
  return {
    getMenuList: function getMenuList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/menu/list",
        method: "get",
        params: data
      });
    },
    getMenuChildList: function getMenuChildList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/menu/child",
        method: "get",
        params: data
      });
    },
    addMenu: function addMenu() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/menu/save",
        method: "post",
        data: data
      });
    },
    updateMenu: function updateMenu() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/menu/update",
        method: "post",
        data: data
      });
    },
    deleteMenu: function deleteMenu() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/menu/delete",
        method: "post",
        data: data
      });
    },
    getMenuButtonList: function getMenuButtonList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/menu/button/list",
        method: "get",
        params: data
      });
    },
    addMenuButton: function addMenuButton() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/menu/button/save",
        method: "post",
        data: data
      });
    },
    updateMenuButton: function updateMenuButton() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/menu/button/update",
        method: "post",
        data: data
      });
    },
    deleteMenuButton: function deleteMenuButton() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/menu/button/delete",
        method: "post",
        data: data
      });
    }
  };
});